import React from 'react';
import Notification from '../Notification/Notification';
import './ChildProfileView.css';
import piggyimage from '../../assets/Images/UnderConstruction.png'


function ChildProfileView () {
    return (
        <div className="profile-view-container">
        <div>
            <h1>COMING SOON !</h1>
            <h2>Here you will be able to customize the background colors of your app .</h2>
            <img src= {piggyimage} alt="Piggy Bunker Logo" class="piggy-image"></img>
            {/* <Notification message="ChildProfileView !" type="success" onClose={handleClose} /> */}
        </div>
    </div>
    );
}

function handleClose() {
  }

export default ChildProfileView;